import { Menu, Box, Button, TextField } from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import InputMask from 'react-input-mask';

import CustomCalendar from '../calendar/calendar';

interface IProps {
  button: React.ReactNode;
  onChange: (data: string) => void;
  limitDate?: Date;
  classnames?: string;
}

const currentTimeStamp = new Date().toISOString();

const DataCalendar = (props: IProps) => {
  const { button, onChange, limitDate, classnames } = props;

  const [date, setDate] = useState<string>(
    moment(limitDate?.toISOString() || currentTimeStamp).format('DD/MM/YYYY'),
  );

  const [datetime, setDatetime] = useState(limitDate?.toISOString() || currentTimeStamp);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApply = () => {
    handleClose();
    onChange(moment(datetime).toISOString());
  };

  const handleUpdateCalendar = (value: Date) => {
    const dateTimeValue = moment();

    dateTimeValue.utc();

    dateTimeValue.set({
      date: value.getDate(),
      month: value.getMonth(),
      year: value.getFullYear(),
    });

    setDatetime(dateTimeValue.format('YYYY-MM-DDTHH:mm:ssZ'));
    setDate(dateTimeValue.format('DD/MM/YYYY'));
  };

  const handleChangeDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDateString = e.target.value;

    if (!newDateString.includes('_')) {
      const splitDateArr = newDateString.split('/');
      const [day, month, year] = splitDateArr;

      if (!isNaN(parseInt(day)) && !isNaN(parseInt(month)) && !isNaN(parseInt(year))) {
        const currentDate = moment(datetime);

        currentDate.set({
          date: parseInt(day),
          month: parseInt(month) - 1,
          year: parseInt(year),
        });

        setDatetime(currentDate.format('YYYY-MM-DD HH:mm:ss'));
      }
    }
    setDate(newDateString);
  };

  return (
    <div>
      <div className={classnames} style={{ cursor: 'pointer' }} onClick={handleClick}>
        {button}
      </div>
      <Menu
        sx={{ width: '20.5rem' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box>
          <CustomCalendar value={datetime} handler={handleUpdateCalendar} maxDate={limitDate} />
          <Box sx={{ display: 'flex', rowGap: 2, justifyContent: 'space-between', padding: 2 }}>
            <InputMask
              mask="99/99/9999"
              value={date}
              onChange={handleChangeDate}
              className="input-date"
            >
              <TextField size="small" margin="dense" type="text" sx={{ width: '60%' }} />
            </InputMask>
          </Box>
          <Box className="button-wrap">
            <Button variant="outlined" size="small" sx={{ width: '100%' }} onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="contained" size="small" sx={{ width: '100%' }} onClick={handleApply}>
              Apply
            </Button>
          </Box>
        </Box>
      </Menu>
    </div>
  );
};

export default DataCalendar;
